import { render } from "./AutoLettura.vue?vue&type=template&id=8423614c&scoped=true"
import script from "./AutoLettura.vue?vue&type=script&lang=js"
export * from "./AutoLettura.vue?vue&type=script&lang=js"

import "./AutoLettura.vue?vue&type=style&index=0&id=8423614c&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8423614c"]])

export default __exports__